/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Invalid_TransitionInputs */

const en_error_invalid_transition = /** @type {(inputs: Error_Invalid_TransitionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This action is not possible in the current status.`)
};

/**
* | output |
* | --- |
* | "This action is not possible in the current status." |
*
* @param {Error_Invalid_TransitionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_invalid_transition = /** @type {((inputs?: Error_Invalid_TransitionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Invalid_TransitionInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_invalid_transition(inputs)
});